import {MatchVideoEmbeddingEvent} from './MatchVideoEmbeddingEvent';

export class MatchVideoEmbeddingCreated extends MatchVideoEmbeddingEvent {}
